import {afterRenderEffect, Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class ToggleThemeService {

  toggleAccessibility: boolean = false;
  themeToggle = false;
  constructor() {
    afterRenderEffect(() => {
      const prefersDark = window.matchMedia('(prefers-color-scheme: dark)');
      this.initializeDarkTheme(prefersDark.matches);
      prefersDark.addEventListener('change', (mediaQuery) => this.initializeDarkTheme(mediaQuery.matches));
    })
  }
  count: number = 0;
  accessibilityApply() {
    let className: string;
    switch (this.count) {
      case 1: {
        this.count = 2;
        document.documentElement.style.fontSize = '18px';
        break;
      }
      case 2: {
        this.count = 0;
        document.documentElement.style.fontSize = '20px';
        break;
      }
      default: {
        this.count = 1;
        className = '';
        document.documentElement.style.fontSize = '16px';
      }
    }
  }
  // Check/uncheck the toggle and update the theme based on isDark
  initializeDarkTheme(isDark: boolean) {
    this.themeToggle = isDark;
    this.toggleDarkTheme(isDark);
  }
  toggleChange(event: CustomEvent) {
    this.toggleDarkTheme(event.detail.checked);
  }

  // Add or remove the "dark" class on the document body
  toggleDarkTheme(shouldAdd: boolean) {
    document.body.classList.toggle('dark', shouldAdd);
  }
}
